export enum BillingPeriodUnit {
  Day = 1,
  Week = 2,
  Month = 3,
  Year = 4
}

export enum BillingAnchorType {
  Immediate = 1,
  Calendar = 2
}